
export const config = {
  "baseUrl": "https://irgogps.com/",
  get token() { return window.sessionStorage.getItem("token") || window.localStorage.getItem('token'); },
  get role() { return window.sessionStorage.getItem("role") || window.localStorage.getItem('role') || 'client'; }
};